<footer class="footer-deployment text-center mt-3 pt-2 text-white d-flex flex-column text-secondary">
  <p class="mx-auto mb-0 small cursor-default">{{ 'common.createdBy' | translate }}</p>
  <p class="mx-auto text-center">
    <a href="https://www.mangonel.io/" target="_blank" class="no-underline d-inline-flex align-items-center justify-content-center text-secondary">
      <img src="../../../assets/imgs/Profile_FeedbackV1/mangonel_favicon.png">
      <span class="ml-2">Mangonel</span>
    </a>
  </p>
  <button
    type="button"
    class="footer-deployment-toggle mx-auto"
    (click)="toggleDeploymentInfo()"
    [attr.aria-expanded]="deploymentInfoVisible"
    aria-controls="footerDeploymentInfo">
    {{ 'deployment.info' | translate }}
  </button>
  @if (deploymentInfoVisible) {
    <p id="footerDeploymentInfo" class="footer-deployment-info mx-auto text-center text-sm">
      @if (getLastUpdated(apiVersion)) {
        <span>{{ 'deployment.lastUpdated' | translate:{ value: getLastUpdated(apiVersion) } }}</span>
        <br/>
      }
      <!-- this is set during the build using devscripts/nogosh.sh and a sed replacement-->
      {{ 'deployment.webDeploy' | translate:{ commit: webCommitId, timestamp: formatDeploymentTimestamp(webDeploymentDate) } }}
      @if (apiVersion) {
        <br/>
        {{ 'deployment.apiDeploy' | translate:{ commit: apiVersion.apiCommitId, timestamp: formatDeploymentTimestamp(apiVersion.apiDeploymentDate) } }}
      }
    </p>
  }
    
</footer>
